module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_footer_image_02-ab60fb9f5ade79a1b4936459cd323e9e.jpg";